import { createContext } from 'react'

import { useHttpScreenFeatureTransport } from './http-transport'

export type ScreenFeatureResource = 'screen' | 'global'

/**
 * The seam between the hook and the server (KTD6). Two adapters: HTTP
 * (`http-transport.ts`) and the in-memory fake (`testing/fake-transport.ts`).
 *
 * `schoolId` is the TARGET school, sent as the `school_id` query param.
 * `undefined` means the fleet-default row; only the hook's `SYSTEM_DEFAULTS`
 * path ever passes it. Both methods reject with a `ScreenFeatureError`.
 */
export interface ScreenFeatureTransport {
  /** Resolves the merged block for one entry (the response's `data`). */
  get(resource: ScreenFeatureResource, wireName: string, schoolId: string | undefined): Promise<unknown>
  patch(
    resource: ScreenFeatureResource,
    wireName: string,
    body: object,
    options: { schoolId: string | undefined; partial: boolean }
  ): Promise<void>
}

/**
 * The context carries a HOOK that yields the transport, not the transport
 * itself, so the default (no provider) can build the HTTP adapter from Clerk
 * while a test provider hands back the fake without any Clerk in the tree. A
 * tree's provider never changes, so the hook called is the same every render.
 * `null` from the hook means "not ready yet" (Clerk still loading).
 */
export const ScreenFeatureTransportContext = createContext<{ useTransport: () => ScreenFeatureTransport | null }>({
  useTransport: useHttpScreenFeatureTransport
})
